import { OrderMethod } from '../../../../../services/exports/Constants';

export default {
  [OrderMethod.Pickup]: 'Odbiór',
  [OrderMethod.Delivery]: 'Dostawa',
  [OrderMethod.OnSite]: 'Zamówienie do stolika',
};
